import { bff } from '@/lib/http/bff';

export type LlmProvider = 'openai' | 'gemini';

export interface OpenAIUsage {
  input_tokens?: number;
  output_tokens?: number;
  total_tokens?: number;
}

export interface OpenAITextResponse {
  ok: true;
  provider?: LlmProvider;
  model: string;
  content: string;
  usage?: OpenAIUsage;
}

export interface CreateTextInput {
  system_prompt: string;
  user_prompt: string;
  llm_provider?: LlmProvider;
  model?: string;
  temperature?: number;
  max_output_tokens?: number;
}

export const createOpenAITextApi = (payload: CreateTextInput): Promise<OpenAITextResponse> =>
  bff.post<OpenAITextResponse>('/ai/text', payload, { timeoutMs: 120_000 });
